module.exports = __webpack_public_path__ + "img/dp-lc-bg.2bfa139b.png";